export class UnitDescription1073Layout {
	public sections = [
		{
			title: 'General Description',
			items: [
				[
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementTotalRoomCount'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementGradeBedrooms'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementGradeFullBathrooms'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementGradeHalfBathrooms'
						}
					}
				],
				[
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementGradeGLA',
							displayType: 'gla'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVStructureUnitFloorIdentifier'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVStructureUnitLevelCount'
						}
					}
				]
			]
		},
		{
			title: 'Assessments',
			items: [
				[
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectAnalysisUnitChargeMonthlyAmount'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectAnalysisUnitChargeAnnuallyAmount'
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectAnalysisUnitChargePerSquareFootAmount'
						}
					}
				],
				[
					{
						cssClass: 'col-sm-12',
						type: 'static-table',
						options: {
							header: [
								{ 
									label: 'Utilities included in the unit monthly assessment',
									colSpan: 4
								}
							],
							rows: [
								{
									cols: [
										{ 
											options: { label: 'Heating' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectAnalysisUnitChargeMonthlyHeatingUtilityIndicator',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: { label: 'Cooling' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectAnalysisUnitChargeMonthlyCoolingUtilityIndicator',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Water' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectAnalysisUnitChargeMonthlyWaterUtilityIndicator',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: { label: 'Electricity' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectAnalysisUnitChargeMonthlyElectricityUtilityIndicator',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Gas' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectAnalysisUnitChargeMonthlyGasUtilityIndicator',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: { label: 'Sewer' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectAnalysisUnitChargeMonthlySewerUtilityIndicator',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Cable' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectAnalysisUnitChargeMonthlyCableUtilityIndicator',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: { label: 'Other' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectAnalysisUnitChargeMonthlyOtherUtilityIndicator',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
									]
								}
							]
						}
					}
				]
			]
		},
		{
			title: 'Heating & Cooling',
			items: [
				[
					{
						cssClass: 'col-md-3',
						type: 'static-table',
						options: {
							header: [
								{ 
									label: 'Type of Cooling',
									colSpan: 2
								}
							],
							rows: [
								{
									cols: [
										{ 
											options: { label: 'Central A/C' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementCoolingCentralized',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Individual' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementCoolingIndividual',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Other' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementCoolingOther',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					},
					{
						cssClass: 'col-md-9',
						type: 'multi-rows',
						fields: [
							[
								{
									cssClass: 'col-md-4',
									type: 'field',
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementCoolingDescription'
									}
								},
								{
									cssClass: 'col-md-4',
									type: 'field',
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVStructureHeatingUnitDescription'
									}
								},
								{
									cssClass: 'col-md-4',
									type: 'field',
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementHeatingFuelType'
									}
								}
							],
							[
								{
									cssClass: 'col-md-6',
									type: 'field',
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVStructureHeatingCoolingMeteredSeparatelyIndicator',
										displayType: 'bool'
									}
								},
								{
									cssClass: 'col-md-6',
									type: 'field',
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVStructureHeatingCoolingMeteredSeparatelyDescription'
									}
								}
							]
						]
					}
				],
			]
		},
		{
			title: 'Appliances',
			items: [
				[
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementEquipmentRefrigerator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementEquipmentRangeOven',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementEquipmentDishwasher',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementEquipmentDisposal',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementEquipmentMicrowave',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementEquipmentWasherDryer',
							displayType: 'bool'
						}
					}
				],
				[
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementEquipmentOther',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-10',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementEquipmentOtherDescription'
						}
					}
				]
			]
		},
		{
			title: 'Amenities',
			items: [
				[
					{
						cssClass: 'col-md-6',
						type: 'static-table',
						options: {
							header: [
								{ label: 'Amenity' },
								{ label: 'Exists?' },
								{ label: 'How Many?' }
							],
							rows: [
								{
									cols: [
										{ 
											options: { label: 'Fireplaces' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityFireplace',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityFireplaceCount',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Woodstoves' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityWoodStove',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityWoodStoveCount',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'static-table',
						options: {
							header: [
								{ label: 'Amenity' },
								{ label: 'Exists?' },
								{ label: 'How Many?' }
							],
							rows: [
								{
									cols: [
										{ 
											options: { label: 'Fence' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityFence',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityFenceDescription',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Patio/Deck' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityPatio',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityPatioDescription',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Porch' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityPorch',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityPorchDescription',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Pool' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityPool',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityPoolDescription',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Other' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityOther',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityOtherDescription',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					}
				],
				[
					{
						cssClass: 'col-md-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityComments'
						}
					}
				]
			]
		},
		{
			title: 'Car Storage',
			items: [
				[
					{
						cssClass: 'col-md-6',
						type: 'multi-rows',
						fields: [
							[
								{
									type: 'field',
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementCarStorageIndicator',
										displayType: 'bool'
									}
								}
							],
							[
								{
									type: 'field',
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVStructureCarStorageParkingSpacesCount'
									}
								}
							],
							[
								{
									type: 'field',
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVStructureCarStorageParkingSpaceAssignmentType'
									}
								}
							],
							[
								{
									type: 'field',
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVStructureCarStorageParkingSpaceIdentifier'
									}
								}
							]
						]
					},
					{
						cssClass: 'col-md-6',
						type: 'static-table',
						options: {
							header: [
								{ label: 'Type' },
								{ label: 'Exists?' }
							],
							rows: [
								{
									cols: [
										{ 
											options: { label: 'Garage' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementCarStorageGarageIndicator',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Covered' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVStructureCarStorageCoveredIndicator',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Open' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVStructureCarStorageOpenIndicator',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					}
				]
			]
		},
		{
			title: 'Interior',
			items: [
				[
					{
						cssClass: 'col-md-6',
						type: 'static-table',
						options: {
							header: [
								{ label: 'Item' },
								{ label: 'Material & Condition' }
							],
							rows: [
								{
									cols: [
										{ 
											options: { label: 'Floors' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementFloorsMaterial',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Walls' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementInteriorWallsMaterial',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Trim/Finish' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementInteriorTrimAndFinishMaterial',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'static-table',
						options: {
							header: [
								{ label: 'Item' },
								{ label: 'Material & Condition' }
							],
							rows: [
								{
									cols: [
										{ 
											options: { label: 'Bath Wainscot' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementInteriorBathroomWainscotMaterial',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Doors' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVStructureDoorsCondition',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					}
				]
			]
		},
		{
			title: 'Condition',
			items: [
				[
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: "CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank='0'].CVStructureQualityOfConstruction"
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: "CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank='0'].CVStructureCondition"
						}
					}
				],
				[
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVUpdateLastFifteenYear',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'static-table',
						options: {
							header: [
								{ label: 'Area' },
								{ label: 'Improvements' },
								{ label: 'Date' }
							],
							rows: [
								{
									cols: [
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAreaType1',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAreaType1DescriptionType',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAreaType1EstimateYearOf',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAreaType2',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAreaType2DescriptionType',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAreaType2EstimateYearOf',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
							]
						}
					}
				],
				[
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVPropertyPhysicalDeficiency',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVPropertyPhysicalDeficiencyDescription'
						}
					}
				],
				[
					{
						cssClass: 'col-md-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVPropertyConditionComment',
						}
					}
				],
				[
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVConformsToNeighborhood',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-8',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVConformsToNeighborhoodDescription'
						}
					}
				]
			]
		}
	];
}